
var VRC = VRC || {};
/**
 * Voyage log manager. Handles all voaygeLogs entries.
 * @type {{add, getAll, getCargoEvents, clear, save, load, toJson, remove, getLast, getEvent, getEventById, importVoyageLogs, getFirst, getNextEvent}}
 */
VRC.VoyageLogEntryManager = (function () {
	var _logEntries = [];
	var CARGOITEM_EVENTS = [105]; //TODO: This should be removed in v1.46 release as we are going to use event codes instead (#43161)
	var CARGOITEM_EVENT_CODES = ['cargo_action'];

	var add = function (logEntry) {
		_logEntries.push(logEntry)
	};

	var getAll = function () {
		return _logEntries;
	};

	var getCargoEvents = function () {
		if (_logEntries.length === 0) {
			load();
		}
		return _.filter(_logEntries, function (event) {
			return _.contains(CARGOITEM_EVENT_CODES, event.getEventCode()) || _.contains(CARGOITEM_EVENTS, event.getEventType()) // TODO: Remove CARGOITEM_EVENTS conidtion
		});
	};

	var remove = function (id) {

		for (var ii = _logEntries.length - 1; ii >= 0; ii--) {
			if (_logEntries[ii].getId() === id) {
				_logEntries.splice(ii, 1);
			}
		}

	};

	var importVoyageLogs = function (voyageLogs) {
		set(voyageLogs);
		save();
	};

	var set = function (localEvents) {
		clear();
		_.each(localEvents, function (localEvent) {
			add(VRC.VoyageLogEntry(localEvent));
		})
	};

	var load = function () {
		var voyageLogs = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.VOYAGE_LOG);
		set(voyageLogs);
	};

	var clear = function () {
		_logEntries = [];
	};

	var save = function () {
		var json = toJson();
		g_localsave_object.SetLocalStorageItem(G_LS_NAMES.VOYAGE_LOG, json);
	};

	var toJson = function () {
		var jsonArray = [];
		$.each(_logEntries, function (index, log) {
			jsonArray.push(log.toJson());
		});
		return jsonArray;
	};

	var getEvent = function (eventType, location, dateTime) {
		return _.find(_logEntries, function (logEntry) {

			return logEntry.isMatch(eventType, location, dateTime);
		});
	};
	var getEventById = function (voyageLogId) {
		return _.find(_logEntries, function (logEntry) {

			return logEntry.getId() === voyageLogId;
		});
	};

	var getNextEvent = function (voyageLog) {
		if (typeof voyageLog !== 'object') {
			voyageLog = getEventById(voyageLog);
		}

		var sortedEvents = _.sortBy(_logEntries, function (logEntry) {
			return moment(logEntry.getDateTime(), g_timeStampFormat).toISOString();
		});

		var idx = sortedEvents.indexOf(voyageLog);
		var nextEvent;
		if (sortedEvents.length >= idx + 2) {
			nextEvent = sortedEvents[idx + 1];
		}
		return nextEvent;
	};

	var getLastEvent = function () {
		var logEntries = VRC.VoyageLogEntryManager.getAll();
		if (logEntries.length > 0) {
			return _.max(logEntries, function (logEntry) {
				return moment(logEntry.getDateTime(), g_timeStampFormat).valueOf();
			});
		}
		else {
			return null;
		}
	};

	var getFirst = function () {
		var voyageLog = getAll();
		var firstEvent;

		if (!voyageLog) {
			return firstEvent;
		}

		$.each(voyageLog, function (index, voyageLogEntry) {
			var dateString = voyageLogEntry[2] + ' ' + voyageLogEntry[3];
			try {
				var date = moment(dateString, g_timeStampFormat);
				if (!firstEvent) {
					firstEvent = voyageLogEntry;
				}
				else if (date.isBefore(firstEvent)) {
					firstEvent = date;
				}
			}
			catch (e) {
				console.error(e);
			}
		});
		return firstEvent;
	};

	return {
		add: add,
		getAll: getAll,
		getCargoEvents: getCargoEvents,
		clear: clear,
		save: save,
		load: load,
		toJson: toJson,
		remove: remove,
		getLast: getLastEvent,
		getEvent: getEvent,
		getEventById: getEventById,
		importVoyageLogs: importVoyageLogs,
		getFirst: getFirst,
		getNextEvent: getNextEvent

	}
})();
